import { transformRelativeImports } from './relative-imports';
import type { CodeTransformIds } from './types';

/**
 * Transforms source code of an example to:
 * - Remove relative paths and replace them with package names
 * - Apply code transformations
 */
export const transformCode = (
	source: string,
	packageName: string,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	options?: {
		/**
		 * A list of code transformations to disable for individual examples.
		 * This is useful for examples that are not compatible with the default code transformations.
		 *
		 * For example, if you want to disable the migration icons code transformation for an example
		 * that demonstrates migration icons.
		 */
		disableCodeTransforms?: CodeTransformIds;
	},
): string => {
	let transformedSource = source;

	transformedSource = transformRelativeImports(source, { packageName });

	transformedSource = transformedSource.trim();

	return transformedSource;
};
